import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { Car } from 'store/slices/cars/types';

export type UpcomingAction = {
  id: string;
  date: Date | null;
  title: string;
  fileUrl?: string | null;
  file?: File;
  carId?: string;
  car?: Car;
  createdAt?: Date;
  updatedAt?: Date;
};

interface InitialState {
  items: Array<UpcomingAction>;
  isPending: boolean;
}

const initialState: InitialState = {
  items: [],
  isPending: false,
};

export const upcomingActionsSlice = createSlice({
  name: 'upcomingActions',
  initialState,
  reducers: {
    resetStore: (state) => {
      return {
        ...state,
        ...initialState,
      };
    },
    updateUpcomingAction: (state, action: PayloadAction<UpcomingAction>) => {
      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.payload.id ? action.payload : item,
        ),
      };
    },
    setUpcomingActionsPendingStatus: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      return {
        ...state,
        isPending: action.payload,
      };
    },
    setUpcomingActions: (
      state,
      action: PayloadAction<Array<UpcomingAction>>,
    ) => {
      return {
        ...state,
        items: action.payload,
      };
    },
    setNewUpcomingAction: (state, action: PayloadAction<UpcomingAction>) => {
      return {
        ...state,
        items: state.items.concat(action.payload),
      };
    },
  },
});
